import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  LayoutDashboard,
  MessageSquare,
  Zap,
  Package,
  ShoppingCart,
  HelpCircle,
  Users,
  BarChart3,
  Settings,
  ChevronLeft,
  ChevronRight,
  CreditCard,
} from 'lucide-react';
import { cn } from '@/lib/utils';


// CORRECT ✅ — yeh karo
const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard',     path: '/app/dashboard' },
  { icon: MessageSquare,   label: 'Conversations', path: '/app/conversations' },
  { icon: Zap,             label: 'Automation',    path: '/app/automation' },
  { icon: Package,         label: 'Products',      path: '/app/products' },
  { icon: ShoppingCart,    label: 'Catalog',       path: '/app/catalog' },   // ← YEH ADD KARO
  { icon: HelpCircle,      label: 'FAQs',          path: '/app/faqs' },
  { icon: Users,           label: 'Leads',         path: '/app/leads' },
  { icon: BarChart3,       label: 'Analytics',     path: '/app/analytics' },
  { icon: Settings,        label: 'Settings',      path: '/app/settings' },
  { icon: CreditCard,      label: 'Subscription',  path: '/app/subscription' }
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <motion.aside
      initial={false}
      animate={{ width: collapsed ? 80 : 240 }}
      className="relative border-r border-border bg-black/80 backdrop-blur-xl"
      data-testid="sidebar"
    >
      <div className="flex flex-col h-full p-4">
        {/* Logo */}
        <div className="flex items-center justify-between mb-8">
          {!collapsed && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="flex items-center gap-2"
            >
              <div className="w-8 h-8 rounded-lg bg-whatsapp flex items-center justify-center">
                <MessageSquare className="w-5 h-5 text-black" />
              </div>
              <span className="font-outfit font-semibold text-lg text-foreground">
                TrueChattr
              </span>
            </motion.div>
          )}
          <button
            data-testid="sidebar-toggle"
            onClick={() => setCollapsed(!collapsed)}
            className="p-1.5 rounded-md hover:bg-secondary/50 transition-colors text-muted-foreground"
          >
            {collapsed ? (
              <ChevronRight className="w-5 h-5" />
            ) : (
              <ChevronLeft className="w-5 h-5" />
            )}
          </button>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={cn(
                  'flex items-center gap-3 px-3 py-2.5 rounded-md transition-all relative overflow-hidden group',
                  isActive
                    ? 'bg-whatsapp/10 text-whatsapp'
                    : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                )}
              >
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 bg-whatsapp/10 rounded-md"
                    initial={false}
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                  />
                )}
                <item.icon className={cn('w-5 h-5 relative z-10', collapsed && 'mx-auto')} />
                {!collapsed && (
                  <span className="font-medium text-sm relative z-10">{item.label}</span>
                )}
              </Link>
            );
          })}
        </nav>
      </div>
    </motion.aside>
  );
}
